import logo from './logo.svg';
import './App.css';
import { getData } from './utils/storage';
import Toast from './components/Toast';
import { BrowserRouter, Navigate, Route, Router, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Package from './pages/Package';
import Payment from './pages/Payment';
import PaymentSuccess from './pages/PaymentSuccess';


const ProtectedRoute = ({ children }) => {
  const login = getData('login');
  const userData = getData('data');
  
  if (login === 'User' && userData) {
    return children;
  }
  
  return <Navigate to="/" replace />;
};


function App() {
  return (
    <>
    <BrowserRouter>
      <div className="App">
        <Toast />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          
          {/* Protected Routes */}
          {/* <Route path="/login2" element={
            <ProtectedRoute>
              <Login2 />
            </ProtectedRoute>
          } /> */}
          
          <Route path="/package" element={
            <ProtectedRoute>
              <Package />
            </ProtectedRoute>
          } />
          <Route path="/payment" element={
            <ProtectedRoute>
              <Payment />
            </ProtectedRoute>
          } />
          <Route path="/paymentSuccess" element={
            <ProtectedRoute>
              <PaymentSuccess />
            </ProtectedRoute>
          } />
          <Route path="/Success" element={
            <ProtectedRoute>
              <Payment />
            </ProtectedRoute>
          } />
          <Route path="/Failed" element={
            <ProtectedRoute>
              <Payment />
            </ProtectedRoute>
          } />
          
          
          {/* Fallback route */}
          {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
        </Routes>
      </div>
    </BrowserRouter>
</>
  );
}

export default App;
